module.exports = __webpack_public_path__ + "static/hiroshimageisenn-logo-transparent-234b5e14bc46ff890ca484ed210ff769.png";